import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputModule } from '@sla-ng/ui-material';
import { MeasureUnitDialogComponent } from './measure-unit-dialog.component';

export * from './measure-unit-dialog.component';
@NgModule({
    declarations: [ MeasureUnitDialogComponent ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        TranslateModule,
        GenericInputModule,
    ],
})
export class MeasureUnitDialogModule {
}
